// angular
// 	.module("HeroPRO")
// 	.factory("DocumentLink", DocumentLinkFactory);

/* @ngInject */
export default function DocumentLinkFactory(HPConfig, FRInformationFactory) {
    return {
        getCompletionCertificateLinkFunding,
        getOtherDocumentsLink,
        getFinancialDocumentsLink,
    };


    function getCompletionCertificateLinkFunding(fundingRequestId, document) {
    // Temporary function until all document links are coming from HEROPro API
        let attachmentLink = '',
            appInfo = FRInformationFactory.getAppInfo();

        // If attachment details do not exist, the latest attachment object is undefined. Added condition to check for CC data in appInfo for this case.
        if (document !== undefined && document !== null && document.LatestAttachment === undefined) {
            if (appInfo !== undefined && appInfo.CompletionCertificateDMDocumentID !== undefined && appInfo.CompletionCertificateDMDocumentID !== null) {
                attachmentLink = `${HPConfig.heroProApi}DocumentManagement/DownloadDocument/?dmdocumentid=${appInfo.CompletionCertificateDMDocumentID}`;
            }
            return attachmentLink;
        }

        if (document.LatestAttachment !== undefined && document.LatestAttachment.AttachmentDetail.DMDocumentId !== undefined &&
    document.LatestAttachment.AttachmentDetail.DMDocumentId !== null && document.LatestAttachment.AttachmentDetail.DMDocumentId !== '') {
            attachmentLink = `${HPConfig.heroProApi}DocumentManagement/DownloadDocument/?dmdocumentid=${document.LatestAttachment.AttachmentDetail.DMDocumentId}`;
        } else if (document.LatestAttachment !== undefined && document.LatestAttachment.AttachmentDetail.DocumentId !== undefined &&
    document.LatestAttachment.AttachmentDetail.DocumentId !== null && document.LatestAttachment.AttachmentDetail.DocumentId !== '') {
            attachmentLink = `${HPConfig.heroProApi}DocumentManagement/DownloadDocument/?dmdocumentid=${document.LatestAttachment.AttachmentDetail.DocumentId}`;
        }

        return attachmentLink;
    }


    function getOtherDocumentsLink(document) {
        let attachmentLink = '';
        if (document.LatestAttachment !== undefined &&
   document.LatestAttachment.AttachmentDetail.DMDocumentId !== undefined && document.LatestAttachment.AttachmentDetail.DMDocumentId !== null &&
   document.LatestAttachment.AttachmentDetail.DMDocumentId !== '') {
            attachmentLink = `${HPConfig.heroProApi}DocumentManagement/DownloadDocument/?dmdocumentid=${document.LatestAttachment.AttachmentDetail.DMDocumentId}`;
        } else if (document.LatestAttachment !== undefined &&
   document.LatestAttachment.AttachmentDetail.DocumentId !== undefined && document.LatestAttachment.AttachmentDetail.DocumentId !== null &&
   document.LatestAttachment.AttachmentDetail.DocumentId !== '') {
            attachmentLink = `${HPConfig.heroProApi}DocumentManagement/DownloadDocument/?dmdocumentid=${document.LatestAttachment.AttachmentDetail.DocumentId}`;
        }

        return attachmentLink;
    }

    function getFinancialDocumentsLink(document) {
        let attachmentLink = '';
        if (document !== undefined && document !== null && document.DMDocumentID !== undefined && document.DMDocumentID !== null && document.DMDocumentID !== '') {
            attachmentLink = `${HPConfig.heroProApi}DocumentManagement/DownloadDocument/?dmdocumentid=${document.DMDocumentID}`;
        } else if (document !== undefined && document !== null && document.DocumentId !== undefined && document.DocumentId !== null && document.DocumentId !== '') {
            attachmentLink = `${HPConfig.heroProApi}DocumentManagement/DownloadDocument/?dmdocumentid=${document.DocumentId}`;
        }

        return attachmentLink;
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/documentLinkFactory.js